/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useTranslation } from "react-i18next";

function ProductCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const handlePrev = () => {
    handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
  };

  const handleNext = () => {
    handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
  };

  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);

  const toggleNav = () => {
    setExpanded(!expanded);
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
    setExpanded(false);
  };

  return (
    <>
      <SRLWrapper>
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          navigation={true}
          pagination={false}
          className="margin-top-30 margin-bottom-30"
        >
          <SwiperSlide>
            <div className="album-list-item">
              <Link
                className="ali-link"
                onClick={handleClick}
                as={Link}
                to="/Armur"
              >
                <div className="ali-img-wrap">
                  <div>
                    <img
                      className="img-fluid blur-up lazyload"
                      src="assets/images/1.png"
                      alt="image"
                      title="image"
                    />
                  </div>
                </div>
              </Link>
            </div>
          </SwiperSlide>
        </Swiper>
      </SRLWrapper>
    </>
  );
}

export default ProductCarousel;
